import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  APP_INITIALIZER,
  PLATFORM_ID,
  inject,
  provideZoneChangeDetection,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PreloadAllModules, provideRouter, withInMemoryScrolling, withPreloading } from '@angular/router';
import { appRoutes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideNativeDateAdapter } from '@angular/material/core';

import { authInterceptor } from '@nexchat/core/src/app/service/auth.interceptor';
import { tenantInterceptor } from './interceptors/tenant.interceptor';
import { GuestTokenService } from '@nexchat/core/src/app/service/guest-token.service';

// Factory function to fetch the Guest Token on application startup
export function initGuestToken(guestTokenService: GuestTokenService) {
  const platformId = inject(PLATFORM_ID);

  return () => {
    // Skip API call during Server-Side Rendering (SSR)
    if (!isPlatformBrowser(platformId)) {
      return Promise.resolve(true);
    }

    // Run only in browser
    return guestTokenService.fetchGuestToken().catch((err) => {
      console.error('Failed to fetch guest token on startup, continuing bootstrap:', err);
      return true;
    });
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      appRoutes,
      withPreloading(PreloadAllModules),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled'
      })
    ),
    provideAnimationsAsync(),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor, tenantInterceptor])),
    provideNativeDateAdapter(),
    
    // Register the APP_INITIALIZER so the guest token is loaded during application startup
    {
      provide: APP_INITIALIZER,
      useFactory: initGuestToken,
      deps: [GuestTokenService],
      multi: true
    }
  ],
};
